module.exports = __webpack_public_path__ + "img/image8.0d2302f6.png";